import React, { useState, useEffect } from 'react'
import './styles.scss'
import Heading from '../heading/Heading'
import LeasingRateBox from '../leasing-rate-box/LeasingRateBox';
import { useSelector, useDispatch } from 'react-redux'
import phoneIco from './../../images/phone-ico.svg'
import checkNaN from '../../services/checkNaN';
import formatPrice from '../../services/formatPrice';
import LeasingRateBoxResult from '../leasing-rate-box/LeasingRateBoxResult';


const LeasingRateResult = ( props ) => {
    let callNumber = useSelector(state => state.callNumber);
    let tax = useSelector(state => state.tax); 
    let productPriceEnd = useSelector(state => state.productPriceEnd); 
    let productPrice = useSelector(state => state.productPrice); 
    let activeContract = useSelector(state => state.selectedLease); 
    let isShop = useSelector(state => state.isShop); 
    let leasingTime = useSelector(state => state.leasingTime)
    let rate = useSelector(state => state.rate);
    let rateFrequency = useSelector(state => state.rateFrequency);
    let data = window.AppConfig ? window.AppConfig.modalAxaText : null;
    let chargePrice     = useSelector(state => state.chargePrice)
    return (
        <>
        <div className="result-leasing-rate">
            {/* { !isShop && callNumber &&
                <div className="call-box">
                    <>
                        <div className="icon">
                            <img src={ phoneIco } alt="Zadzwoń"/>
                        </div>
                        <div className="text">
                            <p>W przypadku pytań zadzwoń do GRENKE</p>
                            <a href={"tel:" + callNumber.replace('/', '')}>+{ callNumber }</a>
                            <span>pn. – pt.  8.00 – 16.00</span>
                        </div>
                    </>
                </div>
            } */}
            <div className={"leasing-rate " + (isShop ? 'shop' : '') }>
                <div className="wrap">
                    <div className="shadow-box">
                        <Heading title={ activeContract == 'tradycyjny' ? "Leasing Tradycyjny (z opcją nabycia)" : "Najem Flexrent"} />
                        <div className="values">
                            <div className="value">
                                <p>Wartość przedmiotu:</p>
                                <p>
                                    { checkNaN(formatPrice(productPrice)) } netto
                                </p>
                            </div>
                            <div className="value">
                                <p>Opłata za opracowanie:</p>
                                {/* <p>750,00 zł netto</p> */}
                                <p>{ tax } netto</p>
                            </div>
                            {/* { tax && tax > 0 && */}
                                <div className="value">
                                    <p>Opłata początkowa:</p>
                                    {/* <p>{ tax } netto</p> */}
                                    <p>{ chargePrice } netto</p>
                                </div>
                            {/* } */}
                        
                            {activeContract == "tradycyjny" &&
                                <div className="value">
                                    <p>Wartość końcowa:</p>
                                    <p>{ productPriceEnd } netto</p>
                                </div>
                            }
                            <div className="value">
                                <p>Podstawowy okres umowy:</p>
                                <p>{ leasingTime } miesięcy</p>
                            </div>
                        </div>
                        <LeasingRateBoxResult 
                            text="Do powyższych kwot należy doliczyć podatek VAT. Niniejsza kalkulacja ma jedynie charakter informacyjny i nie stanowi oferty w rozumieniu Kodeksu Cywilnego." 
                        />
                        <div className="texta">
                            {activeContract == 'tradycyjny' &&
                                <>
                                { rateFrequency == 'miesięcznie' &&
                                    <p>Liczba rat skalkulowana dla Podstawowego Okresu Umowy, który zaczyna się od pierwszego dnia kolejnego miesiąca następującego po dacie odbioru Przedmiotu Najmu. Za każdy dzień poprzedzający Podstawowy Okres Umowy, Najemca zobowiązany jest zapłacić wynagrodzenie w wysokości 1/30 raty.</p>
                                }

                                {rateFrequency == 'kwartalnie' && 
                                    <p>Liczba rat skalkulowana dla Podstawowego Okresu Umowy, który zaczyna się od pierwszego dnia kolejnego kwartału następującego po dacie odbioru Przedmiotu Najmu. Za każdy dzień poprzedzający Podstawowy Okres Umowy, Najemca zobowiązany jest zapłacić wynagrodzenie w wysokości 1/90 raty.</p>
                                }
                                </>
                            }
                            {activeContract == 'nowoczesny' &&
                                <>
                                { rateFrequency == 'miesięcznie' &&
                                    <p>Liczba rat skalkulowana dla Minimalnego Okresu Umowy, który zaczyna się od pierwszego dnia kolejnego miesiąca następującego po dacie odbioru Przedmiotu Najmu. Za każdy dzień poprzedzający Minimalny Okres Umowy, Najemca zobowiązany jest zapłacić wynagrodzenie w wysokości 1/30 raty.</p>
                                }

                                {rateFrequency == 'kwartalnie' && 
                                    <p>Liczba rat skalkulowana dla Minimalnego Okresu Umowy, który zaczyna się od pierwszego dnia kolejnego kwartału następującego po dacie odbioru Przedmiotu Najmu. Za każdy dzień poprzedzający Minimalny Okres Umowy, Najemca zobowiązany jest zapłacić wynagrodzenie w wysokości 1/90 raty.</p>
                                }
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {/* <div className="text result-text">
            {activeContract == 'tradycyjny' &&
                <>
                { rateFrequency == 'miesięcznie' &&
                    <p>Liczba rat skalkulowana dla Podstawowego Okresu Umowy, który zaczyna się od pierwszego dnia kolejnego miesiąca następującego po dacie odbioru Przedmiotu Leasingu. Za każdy dzień poprzedzający Podstawowy Okres Umowy, Korzystający zobowiązany jest zapłacić wynagrodzenie w wysokości 1/30 raty.</p>
                }

                {rateFrequency == 'kwartalnie' && 
                    <p>Liczba rat skalkulowana dla Podstawowego Okresu Umowy, który zaczyna się od pierwszego dnia kolejnego kwartału następującego po dacie odbioru Przedmiotu Leasingu. Za każdy dzień poprzedzający Podstawowy Okres Umowy, Korzystający zobowiązany jest zapłacić wynagrodzenie w wysokości 1/90 raty.</p>
                }
                </>
            }
            {activeContract == 'nowoczesny' &&
                <>
                { rateFrequency == 'miesięcznie' &&
                    <p>Liczba rat skalkulowana dla Minimalnego Okresu Umowy, który zaczyna się od pierwszego dnia kolejnego miesiąca następującego po dacie odbioru Przedmiotu Leasingu. Za każdy dzień poprzedzający Minimalny Okres Umowy, Korzystający zobowiązany jest zapłacić wynagrodzenie w wysokości 1/30 raty.</p>
                }

                {rateFrequency == 'kwartalnie' && 
                    <p>Liczba rat skalkulowana dla Minimalnego Okresu Umowy, który zaczyna się od pierwszego dnia kolejnego kwartału następującego po dacie odbioru Przedmiotu Leasingu. Za każdy dzień poprzedzający Minimalny Okres Umowy, Korzystający zobowiązany jest zapłacić wynagrodzenie w wysokości 1/90 raty.</p>
                }
                </>
            }
        </div> */}
        {data && data.list && data.list.length > 0 &&
            <div className="text result-text">
                <h3>{ data.title }</h3>
                <span>Najemca ma obowiązek ubezpieczenia przedmiotu najmu za pośrednictwem GRENKE lub we własnym zakresie.</span>
                <ul>
                    { data.list.map( ( el, key ) => (
                        <li className={key}>{ el }</li>
                    ))}
                </ul>
                <p>{data.text}</p>
            </div>
        }
        </>
    )
}

export default LeasingRateResult;